
<template>
    <div class="center">
      <vs-dialog v-model="active" width="700px">
        <template #header>
          <h4 class="not-margin">
              {{row.asignatura}}
          </h4>
        </template>
        <div>
            <h5>{{row.ciclo_escolar ? ciclo_escolar : 'Ciclo Escolar 2021 - 20222'}}</h5>
            <h5><small>PROFESOR: </small>{{row.docente ? row.docente : 'GALLEGOS TORANZO JOSE RAFAEL'}}</h5>
            <h5><small>CALIFICACIÓN: </small>{{row.calificacion_final ? row.calificacion_final : '8.4'}}</h5>
        </div>
      </vs-dialog>
    </div>
</template>

<script>
export default {
    props:[
    'value',
    'row',
    ],
    data(){
        return{
        active: false,
        boton: []
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>

<style>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>